export const capitalizeFirstLetter = (string: string) => {
    if(!string){
      return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function sanitizeAndJoin(values: string[]): string {
    return values.map(v => v.trim()).filter(v => v).join(',');
  }

export function seperatedStringToArray(string: string, seperator: string): string[] {
  return string.split(seperator).map(value => value.trim()).filter(org => org);
}

export function toSnakeCase(value: string): string {
  return value
    ?.trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}
